import { mapGetters } from 'vuex';
import motime from '@/common/utilities/motime';

export default {
    name: 'propertyOpenhouse',
    inject: ['$eventBus'],
    props: ['disableCollapse'],
    computed: {
        ...mapGetters('glb', ['glb', 'hasAgent', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    mounted() {
        this.$eventBus.$on('property-openhouse', (options) => {
            if (this.dpp.openHouses && this.dpp.openHouses.length) {
                this.openHotlead(this.dpp.openHouses[0], options);
            } else {
                this.openHotlead(null, options);
            }
        });
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showBuyerAgentCTA() {
            const compliance = this.getComplianceMethod()();
            let compRule = compliance[0] && compliance[0].rule;
            return compRule && compRule.indexOf('showBuyerAgentCTA') >= 0;
        },
        isVirtual(d={}) {
            return d.remarks && /virtual/i.test(d.remarks);
        },
        getTimeRange(d) {
            var start = motime.toDateTime(d.date, d.startTime);
            var end = motime.toDateTime(d.date, d.endTime);
            var time = [];
            if (!isNaN(start)) {
                time.push(motime.formatDate(start, { hour: 'numeric', minute: 'numeric', raw: true }));
            }
            if (!isNaN(end)) {
                time.push(motime.formatDate(end, { hour: 'numeric', minute: 'numeric', raw: true }));
            }
            return `${time.join(' - ')}`;
        },
        getOpenDateText(d) {
            var virtualText = this.isVirtual(d) ? 'Virtual:' : '';
            var start = motime.toDateTime(d.date, d.startTime);
            var date = motime.formatDate(start, { weekday: 'long', month: 'long', day: 'numeric', raw: true });
            var time = this.getTimeRange(d);
            return `${virtualText} ${date} ${time}`;
        },
        openHotlead(openhouse, options) {
            if (!options || !options.hotleadType) {
                console.error('openHotlead: options or options.hotleadType is required');
                return null;
            }
            let opt = {
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
                showComment: false,
            };
            if (openhouse) {
                opt.date = motime.toDateTime(openhouse.date, openhouse.startTime);
                opt.time = this.getTimeRange(openhouse);
            }
            if (this.glb.agent.id) {
                opt.ojoFormConfigs = {
                    showCtaLinks: false,
                    showOJOagentInfo: true,
                    showDisclaimer: false,
                    commnetLabel: 'Message',
                };
            }
            if (openhouse) {
                if (this.isVirtual(openhouse)) {
                    opt.hotleadType = 'VirtualTourHotleadInResponsiveDPP';
                } else {
                    opt.hotleadType = options.hotleadType;
                }
                if (options) {
                    opt = Object.assign(opt, options);
                }
                this.$eventBus.$emit('dialog-center', {
                    name: 'mvtHotleadForm',
                    trigger: this.$options.name,
                    opt: opt,
                });
            } else {
                const testRequestTour = this.dpp.isActive;
                this.$eventBus.$emit('property-pop-schedule', {
                    date: testRequestTour ? undefined : new Date(),
                    optionalDate: testRequestTour ? true : false,
                    hotleadType: options.hotleadType,
                    changeDate: true,
                    hotleadTitle: testRequestTour ? this.molang('dpp.hotButton.requestTour') : this.molang('dpp.hotButton.requestaTourWithAddress', {streetAddress: this.dpp.geo.address}),
                    trigger: testRequestTour ? 'propertyTour' : this.$options.name,
                    buttonText: testRequestTour ? this.molang('dpp.hotleadForm.submit') : this.molang('dpp.propertySchedule.requestTour'),
                    hideProfile: testRequestTour,
                    showAddressAndImage: testRequestTour,
                    hotleadSub: testRequestTour ? this.molang('dpp.propertySchedule.seeThisHome') : '',
                    showFormatAddress: false,
                });
            }
        },
    },
};
